module.exports = __webpack_public_path__ + "Cow.svg";